import Stack from '@mui/joy/Stack';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import DropdownApi from '../../../components/DropdownApi';
import MultiDropdownApi from '../../../components/MultiDropdownApi';
import { siteEmployeeAdd, siteEmployeeUpdate } from '../../../service/siteService';
import { PPEEmployeeAdd } from '../../../service/ppeService';
import { FormControl, Grid } from '@mui/material';
import { Fragment, useEffect, useRef, useState } from 'react';
import useApiService from '../../../hooks/useApiService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Avatar } from 'primereact/avatar';
import dayjs from 'dayjs';
import { toPng } from 'html-to-image';
import jsPDF from 'jspdf';

interface HomeAffairsViewDetails {
  idNumber: string;
  name: string;
  surname: string;
  dateOfDeath: string;
  dateOfMarriage: string;
  dateTimeOfMarriage: string;
  deadIndicator: string;
  idBlocked: boolean;
  idIssueDate: string;
  maritalStatus: string;
  birthPlaceCountry: string;
  birthPlaceCountryCode: string;
  photoGuid: string;
  smartCardIssued: string;
  transactionNo: string;
  searchedDate: string;
}

export default function HomeAffairsView(modalProps: any) {
  const [imageBlob, setImageBlob] = useState<Blob | null>(null);
  const elementRef = useRef<HTMLImageElement>(null);

  const details: HomeAffairsViewDetails = modalProps.details;

  console.log("Home Affairs View details == ", details);

  const formatDateOfBirthFromId = (idNumber: string) => {
    if (!idNumber || idNumber.length < 6) return '';

    const year = idNumber.substring(0, 2);
    const month = idNumber.substring(2, 4);
    const day = idNumber.substring(4, 6);

    // Determine century (assume 00-29 is 2000s, 30-99 is 1900s)
    const fullYear = parseInt(year) <= 29 ? `20${year}` : `19${year}`;

    return `${fullYear}/${month}/${day}`;
  };

  const calculateAge = (dateOfBirth: string) => {
    if (!dateOfBirth) return '';

    const birthDate = new Date(dateOfBirth);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // Adjust age if birthday hasn't occurred this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age.toString();
  };

  const getGenderFromId = (idNumber: string) => {
    if (!idNumber || idNumber.length < 7) return 'Unknown';

    const genderDigit = parseInt(idNumber.substring(6, 7));

    if (genderDigit >= 0 && genderDigit <= 4) {
      return 'Female';
    } else if (genderDigit >= 5 && genderDigit <= 9) {
      return 'Male';
    }

    return 'Unknown';
  };

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await fetch(modalProps.image);
        const blob = await response.blob();
        setImageBlob(blob);
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };

    fetchImage();
  }, [modalProps.image]);

  const dateOfBirth = formatDateOfBirthFromId(details?.idNumber);
  const age = calculateAge(dateOfBirth);
  const gender = getGenderFromId(details?.idNumber);


  const idDetails = [{
    label: 'ID Number',
    value: details?.idNumber
  },
  {
    label: 'Surname',
    value: details?.surname
  },
  {
    label: 'First Names',
    value: details?.name
  },
  {
    label: 'Date of Birth',
    value: dateOfBirth
  },
  {
    label: 'Age',
    value: age
  },
  {
    label: 'Gender',
    value: gender
  },
  {
    label: 'Marital Status',
    value: details?.maritalStatus || 'Unknown'
  },
  {
    label: 'Status',
    value: details?.deadIndicator ? 'DEAD' : 'ALIVE'
  }
  ]

  const generatePDF = async () => {
    if (!elementRef?.current) return;

    try {
      const dataUrl = await toPng(elementRef.current);
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const imgProps = pdf.getImageProperties(dataUrl);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(dataUrl, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.addPage();
      const img = new Image();
      img.src = 'XDS Letter_ Inspirit_CIPC and Trust Data_page-0001.jpg';

      img.onload = () => {
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        pdf.addImage(img, 'JPG', 0, 0, pageWidth, pageHeight);
        pdf.save(`${details.name}_${details.surname}_Home_Affairs_ID_Verification.pdf`);
      };
      // pdf.save("portal-content.pdf");
    } catch (err) {
      console.error("PDF generation failed", err);
    }
  };


  return (
    <Fragment>
      <div style={{ textAlign: "end", padding: '10px 10px 0 0' }}>
        <Button
          type="button"
          icon="pi pi-save"
          label="Download Certificate"
          className="p-button-outlined"
          size="small"
          onClick={() => generatePDF()}
        />
      </div>
      <div style={{ width: 970 }} ref={elementRef}>
        <div style={{ backgroundColor: '#1d184b', padding: 15 }}>
          <img src={'DSF_Logo-Low-trimmed2.png'} style={{ width: 100 }} />
        </div>
        <br />
        <label style={{ textAlign: 'center', fontWeight: 'bold', width: '100%', fontSize: 'xxx-large', display: 'block' }}>Home Affairs ID Verification</label>
        <br />
        <div style={{ padding: '0 40px' }}>
          <div style={{ backgroundColor: '#1d184b', padding: 15 }}>
            <label style={{ color: 'white', fontWeight: 'bold' }}>{details?.name} {details?.surname}</label>
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <label style={{ color: 'black', fontWeight: 'bold' }}>
              {details?.idNumber}
            </label>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
              <label style={{ color: 'black', fontWeight: 'bold' }}>
                Search Date: {dayjs(details?.searchedDate).format('D MMMM YYYY HH:mm')}
              </label>
              <label style={{ color: 'black', fontWeight: 'bold' }}>
                Ref # {details?.transactionNo}
              </label>
            </div>
          </div>
          <br />
          <div style={{ width: '100%', textAlign: 'center' }}>
            {
              imageBlob && (
                <img src={URL.createObjectURL(imageBlob)} style={{ width: 200, height: 200 }} />
              )
            }
          </div>
          <br />
          <div style={{ backgroundColor: '#1d184b', padding: 15 }}>
            <label style={{ color: 'white', fontWeight: 'bold' }}>ID Verification</label>
          </div>
          <br />
          {
            idDetails.map((detail, index) => (
              <div key={index} style={{ display: 'flex', padding: '5px 10px' }}>
                <label style={{ color: '#1d184b', fontWeight: 'bold', width: '200px', textAlign: 'left' }}>{detail.label}:</label>
                <label style={{ color: '#1d184b', flex: 1 }}>{detail.value}</label>
              </div>
            ))
          }
          <br />
          <div style={{ backgroundColor: '#1d184b', padding: 15 }}>
            <p style={{ color: 'white', textAlign: 'center' }}>Any personal information obtained from this search will only be used as per the Terms and Conditions
              agreed to and in accordance with applicable data protection laws including the Protection of Personal
              Information Act 2013 (POPI), and shall not be used for marketing purposes.</p>
          </div>
          <br />
          <p style={{ color: 'black', textAlign: 'center' }}>Attached is the confirmation letter from Credibility of Trust and CIPC Lookup Data Provided by XDS for
            your reference.
          </p>
        </div>

      </div>
    </Fragment>
  );
}